import { Department } from './index'
import { SmallSlectionContainer, SmallSelectionText } from './Styles'

interface SmallSelectionProps {
  departments: Department[]
}
import { useTranslation } from 'react-i18next'

export default function SmallSelection({ departments }: SmallSelectionProps) {
  const { t } = useTranslation()
  const display =
    departments.length === 1
      ? departments[0].name
      : t(`{{number}} selected`, { number: departments.length })
  return (
    <SmallSlectionContainer>
      <SmallSelectionText title={display}>{display} </SmallSelectionText>
    </SmallSlectionContainer>
  )
}
